import baseConfig from './baseConfig';
import socialMediaConfig from './socialMediaConfig';

const config = { baseConfig, socialMediaConfig };

export default config;



// WEBPACK FOOTER //
// ./config/config.js